/*
 * Copyright (c) 2020. Jellybean B.V. Apeldoorn
 * Jellybean B.V. Apeldoorn heeft een licentie verleend aan
 * Spin in het Web B.V. Apeldoorn voor het gebruik van deze software-
 * onderdelen in projecten voor derden. U heeft géén toestemming
 * tot inzage of wijziging in de (bron)code van deze onderdelen.
 */

/*
* sihwdatepicker.module.ts
* 8-3-2020 - Jelmer Jellema - Spin in het Web B.V.
*
* Eenvoudige input met datepicker mysql-stringdates of moments.
* Op basis van ngx-datepicker
* <sihwdatepicker [(ngmodel=....)] bsConfig="{bsConfig voor datepicker}" dateType="'mysql'|'moment'"></sihwdatepicker>
*
* Overige attributen (zie de inputs in de code):
* minDate / maxDate: deze mogen een sqlstring of een moment zijn. Speciaal is minDate="now", wat gewoon vandaag is
* placement: overgenomen van bsdatepicker
*
* De bsConfig wordt gemerged met wat standaarden hier. We zetten standaard de NL Locale
*
* Let op: import in je sass main: en zet eventueel een theme
* @import '~ngx-bootstrap/datepicker/bs-datepicker';
*
* Zie de doc voor bsDatepicker qua config en styling https://valor-software.com/ngx-bootstrap/#/datepicker
*/

import {NgModule} from '@angular/core';
import {SihwlogModule} from '../../sihwlog/sihwlog.module';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SihwDatepicker} from './sihwdatepicker';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';


@NgModule({
  declarations: [
    SihwDatepicker
  ],
  imports: [
    SihwlogModule,
    CommonModule,
    FormsModule,
    BsDatepickerModule
  ],
  exports: [SihwDatepicker]
}) export class SihwdatepickerModule {}
